module.exports = __webpack_public_path__ + "img/sword.ce36cfad.png";